import dayjs from 'dayjs';
import Parse from 'parse';
import { getPriorityIdByName } from '../lib/helper';
var ParseCode = Parse.Object.extend("CodeMst");
const parseCode = new Parse.Object('CodeMst');

export const saveCode = (data, isUpdate = false, id) => {
  const { code, desc, priority, type } = data
  debugger;
  const newCodeEntry = new Parse.Object('CodeMst');
  console.log("data hello")
  // Object.keys(data).forEach((key) => {
   
  //   newCodeEntry.set(key,key == "code" ? data[key].toString() : data[key])
  // })
  // isUpdate && parseCode.set("objecId", id);
  newCodeEntry.set("code", code.toString());
  newCodeEntry.set("desc", desc);
  newCodeEntry.set("priority", parseInt(priority));
  newCodeEntry.set("type", parseInt(type));
  return newCodeEntry.save()
}

export const editCode = ({ updateobj, data }) => {
  console.log("data , data", updateobj, data);

  const { code, desc, priority, type } = data
  updateobj.set('code', code.toString());
  updateobj.set('desc', desc);
  updateobj.set("priority", parseInt(priority));
  updateobj.set("type", parseInt(type));
  return updateobj.save()

  //////////////////////////////////////////
  // let query = new Parse.Query(ParseCode);

  // parseCode.set("objecId",)
  // query.equalTo("id", );
  // query.find({
  //     success: function (results) {

  //         alert("Successfully retrieved " + results.length + "DName");
  //         // - use this-----------------
  //         results.forEach((result) => {
  //             result.set("DName", "aaaa");
  //         });
  //         Parse.Object.saveAll(results);
  //         // --------------------------------
  //     },
  //     error: function (error) {
  //         alert("Error: " + error.code + " " + error.message);
  //     }
  // });
}

export const deleteCode = (deleteObj) => {

  return deleteObj.destroy()

}

export const getCode = async (filters = {}, fields = 'code,desc,priority,type') => {
  let queryFilters = filters
  const { rows, page, first, searchText, sortField, sortOrder } = queryFilters

  let start = dayjs("2021-11-23").startOf("day") //Start of day
  console.log("start ", start.format())
  console.log("pri", getPriorityIdByName("HIGH"))

  const queries = [];

  if (searchText) {
    queries.push(new Parse.Query(parseCode).matches('desc', searchText, "i"));
    queries.push(new Parse.Query(parseCode).matches('code', searchText, "i"));
    queries.push(new Parse.Query(parseCode).equalTo('priority', getPriorityIdByName(searchText)));
  }


  const mainQuery = searchText ? new Parse.Query.or(...queries) : new Parse.Query("CodeMst");
  mainQuery.skip(first)
  mainQuery.limit(rows)
  // mainQuery.descending("createdAt");
  switch (sortOrder) {
    case -1:
      mainQuery.descending(sortField);
      break;
    case 1:
      mainQuery.ascending(sortField);
      break;
    default:
      mainQuery.descending("createdAt");
      break;
  }

  mainQuery.withCount();
  mainQuery.select(fields);
  return mainQuery.find()
}

export const fetchPosts = async (id) => {
  try {
    const { data } = await fetch(`https://gorest.co.in/public/v1/posts`);

    return data;
  } catch (error) {
    throw Error("Unable to fetch Posts");
  }
};